export default __webpack_public_path__ + "static/media/ChiefWiggum.3e3a367b.png";